import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/contact/ContactForm';
import GoogleMap from '../components/contact/GoogleMap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMapMarkerAlt, 
  faEnvelope, 
  faClock 
} from '@fortawesome/free-solid-svg-icons';

const Contact: React.FC = () => {
  const contactInfo = {
    address: "60 Rue Moslard, 92700 Colombes, France",
    phone: "+33 6 81 35 64 70",
    email: "gcmcouverture@gmail.com",
    hours: [
      "Lundi - Vendredi: 8h30 - 18h00",
      "Samedi: 9h00 - 12h00",
      "Dimanche: Fermé"
    ]
  };

  return (
    <div className="pt-16 bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-primary-dark py-16 md:py-24">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-dark to-primary-light opacity-90"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Contactez-nous
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              Notre équipe est à votre disposition pour répondre à toutes vos questions et vous accompagner dans votre projet.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="mb-6 sm:mb-8">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-2 sm:mb-4">
                Envoyez-nous un message
              </h2>
              <p className="text-sm sm:text-base text-gray-600">
                Remplissez le formulaire ci-dessous pour nous contacter. Nous vous répondrons dans les plus brefs délais.
              </p>
            </div>
            
            <ContactForm />
          </motion.div>
          
          {/* Contact Info & Map */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <div className="mb-6 sm:mb-8">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-2 sm:mb-4">
                Informations de contact
              </h2>
              <p className="text-sm sm:text-base text-gray-600">
                Vous pouvez également nous contacter directement par email ou en visitant nos bureaux.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 md:p-8 mb-6 sm:mb-8">
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="bg-primary-dark/10 p-3 rounded-full">
                      <FontAwesomeIcon icon={faMapMarkerAlt} className="text-primary-dark" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-gray-900">Adresse</h3>
                    <p className="text-gray-600 mt-1">{contactInfo.address}</p>
                  </div>
                </div>
                

                
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="bg-primary-dark/10 p-3 rounded-full">
                      <FontAwesomeIcon icon={faEnvelope} className="text-primary-dark" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-gray-900">Email</h3>
                    <p className="text-gray-600 mt-1">
                      <a href={`mailto:${contactInfo.email}`} className="hover:text-primary-dark">
                        {contactInfo.email}
                      </a>
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="bg-primary-dark/10 p-3 rounded-full">
                      <FontAwesomeIcon icon={faClock} className="text-primary-dark" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-gray-900">Horaires d'ouverture</h3>
                    <ul className="text-gray-600 mt-1 space-y-1">
                      {contactInfo.hours.map((hour, index) => (
                        <li key={index}>{hour}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Google Map */}
            <div className="h-64 sm:h-80">
              <GoogleMap address={contactInfo.address} />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
